module.exports = __webpack_public_path__ + "static/media/ELEVEN.24008fc7.png";